import { OrderActionEnum } from 'desk-common';

export interface OrderItemFormValue {
  productId: number | null;
  quantity: number;
  price: number;
}

export interface FormValues {
  costCenterId: number | null;
  items: OrderItemFormValue[];
  action: OrderActionEnum;
}

export const EMPTY_ITEM: OrderItemFormValue = {
  productId: null,
  quantity: 1,
  price: 0,
};

export const DEFAULT_FORM_VALUES: FormValues = {
  costCenterId: null,
  action: OrderActionEnum.SAVE_DRAFT,
  items: [{ ...EMPTY_ITEM }],
};
